export enum Step {
    LICENSE_CHECK = 1,
    DESKTOP_APP_DEFAULTS = 2,
    COLLABORATE_DEFAULTS = 3,
    TRUSTED_LOCATION = 4,
    DEVICE_SETUP = 5,
}

export type CoEditOption = 'Start co-editing automatically' | 'Ask the user' | 'Open file without starting co-editing';

export interface CoEditingSettings {
    word: CoEditOption;
    excel: CoEditOption;
    powerPoint: CoEditOption;
    allowOverwrite: boolean;
}

export interface CollaborateSettings {
    makeDefaultCoEditing: boolean;
}
